import React from 'react';

import { Paper } from '@mui/material';

import classes from './NgzScanIqPaymentResult.module.scss';
import { angularizeWithProviders } from '../../../shared/providers';
import { SuccessfulResult } from './components/SuccessfulResult';
import { ErrorInfo } from '../../components/payment-result/ErrorInfo/ErrorInfo';
import { collectSearchParams } from '../../utils/collectSearchParams/collectSearchParams';
import { useScanIqPaymentResult } from './hooks/useScanIqPaymentResult';

const NgzScanIqPaymentResult = () => {
  const { isSuccess, params, paymentInfo } = useScanIqPaymentResult();

  // We should take the params from the URL before the '#!' part and move them after it
  // Stripe adding own params as a default query params, and we need to move them to the hash portion to be able angular router use them
  if (window.location.search.length) {
    collectSearchParams('scaniq-payment-result');

    return null;
  }

  const renderContent = () => {
    if (!isSuccess) {
      return <ErrorInfo retryPath={params.retryPath} />;
    }

    return (
      <Paper className={classes.box} variant="roundedBox">
        <SuccessfulResult paymentInfo={paymentInfo} retryPath={params.retryPath} />
      </Paper>
    );
  };

  return <div className={classes.container}>{renderContent()}</div>;
};

angularizeWithProviders(NgzScanIqPaymentResult, 'ngzScanIqPaymentResult', {});
